import axiosPost from "../axiosPost";

export const migraPasoUpd = async (
    {
        migraPasoId,
        migraPasoCod,
        migraPasoNombre,
        gateLugarId,
        migraTipoDePasoId,
        migraPasoStatus,
        migraPasoVersion,
    },
    credentials
) => {
    const body = {
        service: "MigraPasoUpd",
        params: {
            migraPasoId,
            migraPasoCod,
            migraPasoNombre,
            gateLugarId,
            migraTipoDePasoId,
            migraPasoStatus,
            migraPasoVersion,
        },
    };

    return await axiosPost(body, credentials);
};
